import { ROUTE } from './route';

// Universal Login (identifiant, mot de passe puis code MFA) : seul l'écran de saisie est délégué à Auth0,
// la session de l'Espace Client reste portée par le JWT interne émis par le BFF.
const AUTH0_CLIENT_OPTIONS = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: `${globalThis.location.origin}${ROUTE.AUTH0CALLBACK}`,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    connection: import.meta.env.VITE_AUTH0_CONNECTION,
    prompt: 'login' as const,
  },
  // Les tokens Auth0 ne servent qu'à l'échange avec le BFF : pas de persistance ni de renouvellement silencieux
  cacheLocation: 'memory' as const,
  useRefreshTokens: false,
};

// Le retour Auth0 (?code=&state=) n'est traité que sur la route de callback
const AUTH0_SKIP_REDIRECT_CALLBACK = globalThis.location.pathname !== ROUTE.AUTH0CALLBACK;

const AUTH0_LOGOUT_RETURN_TO = `${globalThis.location.origin}${ROUTE.LOGIN}`;

// Positionné par la page de callback en cas d'échec, lu (puis effacé) par la page de login pour afficher l'erreur
const AUTH0_LOGIN_ERROR_KEY = 'auth0LoginError';

export { AUTH0_CLIENT_OPTIONS, AUTH0_LOGIN_ERROR_KEY, AUTH0_LOGOUT_RETURN_TO, AUTH0_SKIP_REDIRECT_CALLBACK };
